/*
 * Size selection on Furbuddy recipe rows.
 *
 * One delegated listener rather than a handler per row: the section renders
 * many rows, and the theme editor re-runs section scripts on every render, so
 * per-row binding would stack duplicates.
 *
 * Picking a size rewrites the form's hidden variant id, the price on the
 * button, and its disabled state — the same three things the PDP does.
 */
(function () {
  if (window.__fbRecipeRowInit) return;
  window.__fbRecipeRowInit = true;

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-fb-recipe-size]')) return;
    if (!input.checked) return;

    var row = input.closest('[data-fb-recipe]');
    if (!row) return;

    var variantInput = row.querySelector('[data-fb-recipe-variant-input]');
    if (variantInput) variantInput.value = input.value;

    var amount = row.querySelector('[data-fb-recipe-amount]');
    if (amount && input.dataset.price) amount.textContent = input.dataset.price;

    var unit = row.querySelector('[data-fb-recipe-unit]');
    if (unit) {
      unit.textContent = input.dataset.unitPrice || '';
      unit.hidden = !input.dataset.unitPrice;
    }

    var submit = row.querySelector('[data-fb-recipe-submit]');
    if (submit) submit.disabled = input.dataset.available !== 'true';
  });
})();
